module.exports = ".dropdown-menu{\r\n    max-height: 300px; /*Provide height in pixels or in other units as per your layout*/\r\n    overflow-y: auto; /*Provide an auto overflow to diaply scroll*/\r\n   }"


//////////////////
// WEBPACK FOOTER
// ./src/app/ratings/ratings.component.css
// module id = ./src/app/ratings/ratings.component.css
// module chunks = main